import { API_BASE_URL} from "../Services/baseApiUrl";
import axiosInstance from "../../Hooks/axoisInstance";

const IEC_ACTIVITY_ENDPOINTS = {
  REPORT: `${API_BASE_URL}IECActivity/IECActivityReport`,
};

const toDateParam = (value) => {
  if (!value) return "";
  return String(value).includes("T")
    ? String(value).split("T")[0]
    : String(value).slice(0, 10);
};

const mapIecActivityRow = (item) => ({
  ...item,
  zoneName: item.zone ?? "",
  wardName: item.circle ?? "",
  wardId: String(item.circleId ?? ""),
  dateOfCreation: item.dateOfCreation ?? "",
  activityType: item.activityType ?? "",
  conductedArea: item.conductedArea ?? "",
  location: item.location ?? "",
  remarks: item.remarks ?? "",
  image: item.image ?? "",
  image1: item.image1 ?? "",
});

export const getIecActivityReport = async ({
  wardId = "",
  fromDateTime = "",
  toDateTime = "",
  pageNumber = 1,
  pageSize = 10,
} = {}) => {
  const params = {
    PageNumber: pageNumber,
    PageSize: pageSize,
  };

  if (wardId) params.CircleId = wardId;

  const fromDate = toDateParam(fromDateTime);
  const toDate = toDateParam(toDateTime);
  if (fromDate) params.FromDate = fromDate;
  if (toDate) params.ToDate = toDate;

  const response = await axiosInstance.get(IEC_ACTIVITY_ENDPOINTS.REPORT, {
    params,
  });
  const body = response?.data ?? {};
  const list = Array.isArray(body?.data) ? body.data : [];

  return {
    data: list.map(mapIecActivityRow),
    totalRecords: Number(body?.totalRecords ?? 0),
    pageNumber: Number(body?.pageNumber ?? pageNumber),
    pageSize: Number(body?.pageSize ?? pageSize),
  };
};
